import { useState } from "react";
// outsource
import { Row, Col, Button, InputNumber } from "antd";

const PayoutSettingPayoutRateSection = ({ data, onSave }) => {
  // -------------------------- STATE --------------------------
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState({});

  // -------------------------- FUNCTION --------------------------
  const handleEdit = () => {
    setDraft({ ...data });
    setEditing(true);
  };

  const handleCancel = () => setEditing(false);

  const handleSave = () => {
    onSave(draft);
    setEditing(false);
  };

  // -------------------------- RENDER --------------------------
  const renderHeader = () => (
    <Row align="middle" justify="space-between" style={{ marginBottom: 16 }}>
      <Col>
        <strong>Payout Settings</strong>
      </Col>
      <Col>
        <Row gutter={[8, 0]}>
          {editing ? (
            <>
              <Col>
                <Button size="small" className="ps-cancel-btn" onClick={handleCancel}>
                  Cancel
                </Button>
              </Col>
              <Col>
                <Button type="primary" size="small" className="ps-edit-btn" onClick={handleSave}>
                  Save
                </Button>
              </Col>
            </>
          ) : (
            <Col>
              <Button type="primary" size="small" className="ps-edit-btn" onClick={handleEdit}>
                Edit
              </Button>
            </Col>
          )}
        </Row>
      </Col>
    </Row>
  );

  const renderField = (label, field) => (
    <Row align="middle" gutter={[16, 0]} style={{ marginTop: 12 }}>
      <Col xl={4} lg={5} md={6} xs={10}>
        <span className="ps-label">{label}</span>
      </Col>
      <Col>
        {editing ? (
          <InputNumber
            value={draft[field]}
            min={1}
            step={0.1}
            precision={1}
            className="ps-rate-input"
            onChange={(v) => setDraft((prev) => ({ ...prev, [field]: v }))}
          />
        ) : (
          <div className="ps-value-box">{Number(data?.[field] ?? 0).toFixed(1)}</div>
        )}
      </Col>
    </Row>
  );

  // -------------------------- MAIN --------------------------
  return (
    <div className="ps-section">
      {renderHeader()}
      {renderField("After-Hour Rate", "afterHourRate")}
      {renderField("Holiday Rate", "holidayRate")}
    </div>
  );
};

export default PayoutSettingPayoutRateSection;
